export default __webpack_public_path__ + "static/media/O-026.8ae14967.png";